module.exports = "/pages/business/foodslabo/support_image_1.png";